import Home from "./pages/home/home";

export function App() {
  return <Home />;
}

export default App;
